// Sanitize user input for safe use inside a PostgREST .or() / .ilike() filter.
// Strips reserved PostgREST chars (commas, parens, backslash) and escapes
// ILIKE wildcards (%, _) so user input can't break the filter string.
export function escapeIlike(str) {
  if (!str) return ''
  return str
    .replace(/[(),\\]/g, '')
    .replace(/%/g, '\\%')
    .replace(/_/g, '\\_')
}
